import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class FinanceTagsApi extends ApiModule {
  constructor() {
	super(ModulesMap.FINANCE_TAGS, {
	  entity: 'finance_tags',
	})
  }
}
